import React, { useEffect, useMemo, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import "../assets/css/ViewCustomer.css";
import TestCaseDetailsPanel from "./issues/TestCaseDetailsPanel";
import { fetchTestCaseById } from "./issues/testCaseService";
import { canPerformActionOnPage, PAGES, ACTIONS } from "../utils/roleAccess";

function ViewTestCase() {
  const navigate = useNavigate();
  const { testCaseId } = useParams();
  const role = useMemo(() => {
    try {
      const u = localStorage.getItem("user");
      if (!u) return null;
      const user = JSON.parse(u);
      const primaryRole = Array.isArray(user.roles) && user.roles.length > 0 ? user.roles[0] : null;
      return (
        (primaryRole && (primaryRole.role_name || primaryRole.name || primaryRole.role)) ||
        user.role_name ||
        user.role ||
        null
      );
    } catch {
      return null;
    }
  }, []);
  const canEdit = canPerformActionOnPage(PAGES.ISSUES, ACTIONS.EDIT, role);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [testCase, setTestCase] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await fetchTestCaseById(testCaseId);
        if (!data) {
          setError("Test case not found.");
          setTestCase(null);
        } else {
          setTestCase(data);
        }
      } catch (err) {
        console.error("Error fetching test case:", err);
        setError(err.response?.data?.message || err.response?.data?.error || "Failed to load test case.");
        setTestCase(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [testCaseId]);

  return (
    <div className="viewlead-container">
      <div className="viewlead-header">
        <button type="button" className="viewlead-back-link" onClick={() => navigate("/issues/test-cases")}>
          <FaArrowLeft /> Back to Test Cases
        </button>
        {canEdit ? (
          <button
            type="button"
            className="btn-subproject-primary"
            onClick={() => navigate(`/issues/test-cases/${testCaseId}/edit`)}
          >
            Edit Test Case
          </button>
        ) : null}
      </div>

      {loading ? (
        <div className="viewlead-loading">Loading test case...</div>
      ) : error ? (
        <div className="error-message" style={{ backgroundColor: "#fee", color: "#c33", padding: "12px", borderRadius: "4px", marginBottom: "20px", fontSize: "14px" }}>
          {error}
        </div>
      ) : (
        <TestCaseDetailsPanel testCase={testCase} />
      )}
    </div>
  );
}

export default ViewTestCase;

